import { render } from "./vue-number-input.vue?vue&type=template&id=22fd58ce&scoped=true"
import script from "./vue-number-input.vue?vue&type=script&lang=js"
export * from "./vue-number-input.vue?vue&type=script&lang=js"

import "./vue-number-input.vue?vue&type=style&index=0&id=22fd58ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22fd58ce"]])

export default __exports__